import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import Modal from '../common/Modal';

const Header = () => {
  const { logout, currentUser } = useAuth();
  const navigate = useNavigate();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const handleLogout = () => {
    setShowLogoutConfirm(true);
  };

  const confirmLogout = () => {
    logout();
    setShowLogoutConfirm(false);
  };

  return (
    <>
      <header className="bg-gradient-to-r from-orange-600 via-orange-500 to-orange-400 text-white shadow-lg relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-32 h-32 bg-white opacity-10 rounded-full -translate-y-1/2 translate-x-1/2"></div>
        <div className="absolute bottom-0 left-1/4 w-16 h-16 bg-white opacity-10 rounded-full translate-y-1/2"></div>
        <div className="absolute top-1/2 right-1/3 w-8 h-8 bg-white opacity-10 rounded-full -translate-y-1/2"></div>
        
        <div className="container mx-auto px-6 py-4 flex justify-between items-center relative z-10">
          <div className="flex items-center space-x-3">
            <div className="hidden md:flex items-center mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
            </div>
            <h1 
              className="text-xl md:text-2xl font-bold cursor-pointer tracking-wide" 
              onClick={() => navigate('/')}
            >
              Vital Insights <span className="font-light">Admin Portal</span>
            </h1>
          </div>
          
          {currentUser && (
            <div className="flex items-center space-x-4">
              <div className="hidden md:flex items-center bg-white bg-opacity-20 backdrop-blur-sm rounded-full px-4 py-1.5 shadow-inner border border-white border-opacity-20">
                <div className="bg-white bg-opacity-30 rounded-full p-1 mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
                <span className="text-sm font-medium">
                  {currentUser.name || 'User'}
                </span>
              </div>
              <button
                className="px-4 py-1.5 rounded-full bg-gradient-to-r from-orange-700 to-orange-600 hover:from-orange-800 hover:to-orange-700 transition-all duration-200 border border-white border-opacity-30 flex items-center shadow-md"
                onClick={handleLogout}
              >
                <span className="mr-1 text-sm font-medium">Logout</span>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
              </button>
            </div>
          )}
        </div>
      </header>

      <Modal
        isOpen={showLogoutConfirm}
        onClose={() => setShowLogoutConfirm(false)}
        size="sm"
      >
        <div className="p-6">
          <h3 className="text-lg font-semibold mb-4">Confirm Logout</h3>
          <p className="text-gray-600 mb-6">Are you sure you want to logout?</p>
          <div className="flex justify-end gap-3">
            <button
              className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded"
              onClick={() => setShowLogoutConfirm(false)}
            >
              Cancel
            </button>
            <button
              className="px-4 py-2 text-sm bg-red-500 text-white hover:bg-red-600 rounded"
              onClick={confirmLogout}
            >
              Logout
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Header;